import { getWindowData } from "owa-window-data";

// All UI personalization and differences will be driven by isHostAppFeatureEnabled
export function isRunningInMetaOSHub(): boolean {
    return getWindowData()?.location?.pathname.indexOf("/hosted") == 0;
}
